import { createApi } from '@reduxjs/toolkit/query/react';

import { VotingListApiResponse } from 'src/global/schemas/vote.schema';

import { REDUX_SLICE } from '../constants';
import { axiosBaseQuery } from '../utils';

export const voteApi = createApi({
  reducerPath: REDUX_SLICE.VOTE_API,
  baseQuery: axiosBaseQuery,
  tagTypes: ['Vote'],
  endpoints: builder => ({
    getVotingList: builder.query<
      VotingListApiResponse,
      { address: string; status?: string; projectId?: string; page: number; limit: number }
    >({
      query: arg => ({
        method: 'GET',
        path: `/v1/votes`,
        headers: {
          'x-nodesale-lang': 'en',
          'x-offchain-address': arg.address,
        },
        params: {
          page: arg.page,
          size: arg.limit,
          filter: JSON.stringify({
            ...(arg.status && { status: arg.status }),
            ...(arg.projectId && { programId: arg.projectId }),
          }),
        },
      }),
      providesTags: (_result, _error, { address, status }) => [{ type: 'Vote', id: address, status }],
    }),
    approveProject: builder.mutation<any, { voteId: string; address: string }>({
      query: data => ({
        method: 'POST',
        path: `/v1/votes/${data.voteId}/approved`,
        headers: {
          'x-nodesale-lang': 'en',
          'x-offchain-address': data.address,
        },
      }),
      invalidatesTags(_result, _error, arg, _meta) {
        return [{ type: 'Vote', id: arg.voteId }];
      },
    }),
    rejectProject: builder.mutation<any, { voteId: string; address: string }>({
      query: data => ({
        method: 'POST',
        path: `/v1/votes/${data.voteId}/rejected`,
        headers: {
          'x-nodesale-lang': 'en',
          'x-offchain-address': data.address,
        },
      }),
      invalidatesTags(_result, _error, arg, _meta) {
        return [{ type: 'Vote', id: arg.voteId }];
      },
    }),
  }),
});

export const { useGetVotingListQuery, useApproveProjectMutation, useRejectProjectMutation } = voteApi;
